import PersonIcon from "@mui/icons-material/Person";
import clsx from "clsx";
import { useAtomValue } from "jotai";
import React, { FC } from "react";
import { currentTheme } from "../../../../atoms";
import IconMenuButton from "../../Tools/IconMenuButton";
import { smetaModals } from "../../Tools/modalManager";
import Options from "./Options";
import { selectOrg } from "../../Tools/Tools";
import { checkGenLicGuid, getLastLogin, getOptionsForUser } from "../../../Url";
import PasswordInput from "./PasswordInput";
import { enterSmeta, getUserInfo, updateStatesAfterEnter } from "../../../Singin/SingIn";

// eslint-disable-next-line @typescript-eslint/naming-convention
const UserProfile: FC<{ leave: () => void }> = ({ leave }) => {
  const theme = useAtomValue(currentTheme);
  const userInfo = getOptionsForUser() || {};
  const { isOrgEnter } = userInfo;

  const openSettings = () => {
    smetaModals.open(<Options />, {
      Title: "Настройки",
      style: { height: `${400}px`, width: `${520}px` },
      hiddenButton: true,
      blockMaximize: true,
      setFocus: true,
    });
  };

  const changeOrg = async () => {
    const [drx, user, workPlace] = getLastLogin().split(",");
    const selectedOrg = await selectOrg({ drx, user });
    let typedPassword = "";
    if (!selectedOrg) return;
    const onSelect = async () => {
      checkGenLicGuid("");
      const userInfo = await getUserInfo(selectedOrg.config || drx, user);
      const loginData = {
        configName: selectedOrg.config || drx,
        userName: user,
        workPlace: workPlace,
        password: typedPassword,
        orgTypeCls: selectedOrg.code,
        drx,
      };
      const enterResp = await enterSmeta(loginData, { ip: userInfo.Server || null });
      updateStatesAfterEnter(enterResp, loginData);
      window.location.reload();
    };
    smetaModals.open(
      <>
        <input style={{ opacity: "0.01" }} />
        <PasswordInput
          onChange={(e) => {
            typedPassword = e;
          }}
        />
      </>,
      {
        Title: "Подтвердите пароль",
        style: { height: `${190}px`, width: `${500}px` },
        onSelect: onSelect,
        Buttons: {
          Buttons: 3,
        },
        blockMaximize: true,
      },
    );
  };

  return (
    <IconMenuButton
      title="Профиль"
      items={[
        { label: "Настройки", onClick: openSettings },
        { label: "Выбрать организацию", onClick: changeOrg, hidden: !Boolean(isOrgEnter) },
        { label: "Выйти", onClick: leave },
      ]}
    >
      <PersonIcon className={clsx("iconButtonStimate", { light: theme === "light" })} />
    </IconMenuButton>
  );
};

export default UserProfile;
